import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { setEmailCoupon, autoApplyEmailCoupon } from 'State/PromoCode';

const EMAIL_COUPON_PARAM = 'promoCoupon';
const AUTO_APPLY_COUPON = 'applyCoupon';

export function useEmailCoupon(couponParam = EMAIL_COUPON_PARAM, autoApply = AUTO_APPLY_COUPON) {
  const [couponCode, setCouponCode] = useState('');
  const { search = '' } = useLocation();

  useEffect(() => {
    const searchQuery = new URLSearchParams(search);
    const couponCode = searchQuery.get(couponParam) || null;
    const isAutoApply = searchQuery.get(autoApply) === 'true';
    if (couponCode) {
      const code = couponCode.toUpperCase();
      setEmailCoupon(code);
      setCouponCode(code);
    }
    if (couponCode && isAutoApply) {
      autoApplyEmailCoupon(isAutoApply);
    }
  }, [search, couponParam, autoApply]);
  return couponCode;
}
